export default __webpack_public_path__ + "static/custom-domain-42ceacb1bd43642472ce3e55679587dd.png";